<mat-form-field *ngIf="objets !== undefined && parent && myControl" class="full-width" [formGroup]="parent" [matTooltip]="libelleControl.value" >
  <mat-label>{{libelle}}</mat-label>
    <input
    #matInput
      matInput 
      type= "text"
      [required]="util.hasRequiredField(myControl)"
      [formControl]="myControl"
      [placeholder]="articlePrefix !== '' ? 'Sélectionner ' + articlePrefix + libelle: 'Sélectionner le ' + libelle"
      [matAutocomplete]="auto"
      [ngClass]="{'orangeBack': styles}"
      (change)="$event.target.value === '' ? deleteIfEmpty() : null">
  <mat-autocomplete 
    autoActiveFirstOption 
    panelWidth="auto"
    #auto="matAutocomplete" 
    (optionSelected)="onObjetChange($event)">
    <mat-option *ngFor="let obj of filteredObjets | async" [value]="obj"> {{obj}}</mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="myControl.hasError('forbiddenNames')">
    Veuillez sélectionner une valeur suggérée
  </mat-error>
  <mat-error *ngIf="myControl.hasError('required')">
    Veuillez sélectionner une valeur pour {{libelle}}
  </mat-error>
</mat-form-field>